import React, { useState, useContext } from "react";
import Slider from "@mui/material/Slider";
import styled from "styled-components";
import { WebMapContext } from "../../pages/sections/web-map/WebMapGoogleMap";

function valuetext(value) {
  return `${value}°C`;
}

const minDistance = 0.1;

const StyledSlider = styled(Slider)`
  text-align: left;
  margin: 5px 10px 20x 10px;
  margin-left: 7px;
  margin-right: 7px;
  
  width: 100%;
  & .MuiSlider-valueLabelCircle {
    fontSize: 10px;
  }
`;

const marks = [
  {
    value: 0,
    label: "0",
  },
  {
    value: 1,
    label: "1",
  },
];

export default function RangeSelectSlider({ value = [0, 1], setValue }) {
  const { onChangeDemandScoreRange } = useContext(WebMapContext);

  const handleChange = (event, newValue, activeThumb) => {
    if (!Array.isArray(newValue)) {
      return;
    }
    let min, max;
    if (activeThumb === 0) {
      min = Math.min(newValue[0], value[1] - minDistance);
      max = value[1];
    } else {
      min = value[0];
      max = Math.max(newValue[1], value[0] + minDistance);
    }
    setValue([min, max]);
    onChangeDemandScoreRange([min, max]);
  };

  return (
    <StyledSlider
      getAriaLabel={() => "Minimum distance"}
      value={value}
      size="small"
      onChange={handleChange}
      valueLabelDisplay="auto"
      getAriaValueText={valuetext}
      disableSwap
      step={minDistance}
      min={0}
      max={1}
      marks={marks}
    />
  );
}
